import React from "react";

const CartItemDropdownListItem = ({ children, ...props }) => {
  return <div className="wbmcid-dropdown-item">{children}</div>;
};

export default CartItemDropdownListItem;
